var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-exit",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('span',{staticClass:"flaticon2-reply icon-lg"}),_vm._v(" بازگشت ")])
}
var staticRenderFns = []

export { render, staticRenderFns }